/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import Col from "../../../common/core/Col";
import Button from "../../../common/core/Button";
import Input from "../../../common/core/Input";
import Label from "../../../common/core/Label";
import Modal from "../../../common/core/Modal";
import ModalHeader from "../../../common/core/ModalHeader";
import ModalBody from "../../../common/core/ModalBody";
import ModalFooter from "../../../common/core/ModalFooter";
import Form from "../../../common/core/Form";
import FormGroup from "../../../common/core/FormGroup";
import FormFeedback from "../../../common/core/FormFeedback";
import Alert from "../../../common/core/Alert";
import ValidationConstants from "../../../common/utils/validationConstants";
import Spinner from "../../../common/core/Spinner";

const EditBrand = (props) => {
  const {
    modalContents,
    handleChange,
    editModal,
    toggleEditModal,
    submitEditBrandForm,
    handleSubmit,
    register,
    errors,
    message,
    isSaveInProgress,
  } = props;

  const {
    IS_BRAND_ID, IS_BRAND_NAME,
  } = ValidationConstants;
  return (
    <>
      <Modal isOpen={editModal} toggle={toggleEditModal} centered backdrop="static">
        <ModalHeader toggle={toggleEditModal}>
          Edit Brand
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit(submitEditBrandForm)}>
            {isSaveInProgress
              ? (
                <div className="d-flex align-items-center justify-content-center">
                  <Spinner />
                </div>
              )
              : (
                <>
                  {
                    message && message.type === "warning" && (
                      <Alert color={message.type}>
                        {message.message}
                      </Alert>
                    )
                  }
                </>
              )}
            <fieldset>
              <div className="edit-block last mb-2">
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Brand ID *</Label>
                    <Input
                      type="text"
                      name="brandId"
                      id=""
                      defaultValue={modalContents.brandId}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_BRAND_ID,
                          message: "Invalid Brand Id",
                        },
                      })}
                      invalid={errors.brandId && errors.brandId.message}
                      required
                    />
                    <FormFeedback>
                      {errors.brandId && errors.brandId.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="12" className="edit-item mb-3">
                  <FormGroup>
                    <Label for="" className="me-sm-2">Brand Name *</Label>
                    <Input
                      type="text"
                      name="brandName"
                      id=""
                      defaultValue={modalContents.brandName}
                      onChange={handleChange}
                      innerRef={register({
                        pattern: {
                          value: IS_BRAND_NAME,
                          message: "Invalid Brand Name",
                        },
                      })}
                      invalid={errors.brandName && errors.brandName.message}
                      required
                    />
                    <FormFeedback>
                      {errors.brandName && errors.brandName.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </div>
              <ModalFooter>
                <Button color="primary" className="btn-radius">
                  Save
                </Button>
                <Button color="light" className="btn-radius" onClick={toggleEditModal}>Cancel</Button>
              </ModalFooter>
            </fieldset>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

EditBrand.propTypes = {
  modalContents: PropTypes.objectOf(PropTypes.any).isRequired,
  handleChange: PropTypes.func.isRequired,
  editModal: PropTypes.bool.isRequired,
  toggleEditModal: PropTypes.func.isRequired,
  submitEditBrandForm: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  isSaveInProgress: PropTypes.bool.isRequired,
};
export default EditBrand;
